import { jsonp } from 'utils/request';
import config from '$config';
import activityMeta from 'utils/activityMeta';
const { templateId } = activityMeta;

// 参团接口
export async function joinTeam(params) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/join`, {
    source: JSON.stringify({
      spma: '5176',
      spmb: $('body').context.body.dataset.spm,
      channel: params.channel,
      shareType: params.shareType,
    }),
    ...params,
    templateId,
  });
}

// 参团前校验
export async function joinVerify(params) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/joinVerify`, {
    ...params,
  });
}

// 访问即关联
export async function shareBuildRelation(userCode) {
  return await jsonp(`${config.PROMOTION_ENDPOINT}/promotion/ambassador/shareBuildRelation.htm`, {
    userCode,
    source: JSON.stringify({
      spma: '5176',
      spmb: $('body').context.body.dataset.spm,
    }),
  });
}

// 根据团code获取团信息
export async function getGroupInfo(params) {
  return await jsonp(`${config.DASHI_ENDPOINT}/api/activity/group/info`, {
    ...params,
    templateId,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/services/ShareService.js